/**
 *
 * @param {function} func -  The function to debounce
 * @param {number} limit - A duration in miliseconds
 * @returns {function} - The debounced callback function
 */
export function debounce( func, limit ) {
    let timeout;
    return ( ...args ) => {
        clearTimeout( timeout );
        timeout = setTimeout( func, limit, ...args );
    };
}

/**
 *
 * @param {function} func - Callback function which can only execute once per limit
 * @param {number} limit - A duration in miliseconds, how much to throttle the function
 * @returns {function} - The throttle callback function
 */
export function throttle( func, limit ) {
    let timeout = false;
    return ( ...funcArgs ) => {
        if ( timeout ) return;
        func( ...funcArgs );
        timeout = setTimeout( () => timeout = false, limit );
    };
}

/**
 *
 * @param {number} ms Milliseconds to wait
 * @returns {Promise<undefined>}
 */
export async function sleep(ms) {
    return new Promise( resolve => {
        setTimeout( () => resolve(), ms );
    })
}